import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { authSlice } from "./slices/Auth";
import { dateRangeSlice } from "./slices/dateRangeSlice";
import storage from "redux-persist/lib/storage";
import directTaxSlice from "./directTaxSlice/index";
import tdsSlice from "./tdsSlice/index";
import formOptionsSlice from "./formOptions/index";
import userSlice from "./userSlice/index";
import clientSlice from "./clientProjectSlice/index";
import vendorSlice from "./vendorSlice/index";
import embrillProfileSlice from "./embrillProfileSlice/index";
import legacySlice from "./legacySlice/index";
import {organizationSlice, logoSlice} from "./organizationSlice/index";
import purchaseItemSlice from "./purchaseItemSlice/index";
import AllOrganizationModuleTypeSlice from "./organizationModuleSlice";
import expenseSlice from "./OrganizationExpenseSlice/index";
import AllSalesInvoiceModuleTypeSlice from "./salesInvoiceModuleSlice";
import salesItemSlice from "./salesItemSlice";
import invoieSlice from "./salesInvoice";
import {gstRecordsReducer,
tdsRecordsReducer,
paymentRecordsReducer} from "./invoicePaymentRecordSlice/index";


import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import subCategorySlice from "./subCategorySlice";
import gstSlice from "./slices/gstSlice";
import { filterListDataSlice, searchTextSlice,currencyInvoiceDataSlice } from "./slices/searchTextSlice";

const persistConfig = {
  key: "internal",
  storage,
};

const reducers = combineReducers({
  auth: authSlice.reducer,
  dateRange: dateRangeSlice.reducer,
  searchValue: searchTextSlice.reducer,
  filteredList: filterListDataSlice.reducer,
  currency: currencyInvoiceDataSlice.reducer,
  expenseData: expenseSlice,
  directTaxData: directTaxSlice,
  tdsData: tdsSlice,
  formOptions: formOptionsSlice,
  subCategory: subCategorySlice,
  userData: userSlice,
  clientData: clientSlice,
  vendorData: vendorSlice,
  purchaseItemData:purchaseItemSlice,
  embrillProfileData: embrillProfileSlice,
  legacyData: legacySlice,
  organizationData: organizationSlice,
  logoData:logoSlice,
  gstData: gstSlice,
  moduleType: AllOrganizationModuleTypeSlice,
  salesModule: AllSalesInvoiceModuleTypeSlice,
  salesItemData:salesItemSlice,
  invoiceData: invoieSlice,
  gstRecords:gstRecordsReducer,
  tdsRecords:tdsRecordsReducer,
  paymentRecords:paymentRecordsReducer


});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: false,
    }),
});
